import React from 'react';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
/** import mui components in the section above, Sort Lines Ascending */

import { HistoryTableV3 } from 'widgets/history-table';
import {
    historyDialogContentSx,
    historyDialogProps,
} from 'widgets/history-table/history-dialog-props';
import selector from './selector';
/** import widgets components in the section above, Sort Lines Ascending */

import { closeAdHistory } from './actions';
import { fetchAdHistory } from 'pages/campaigns/ads/ad-history/actions';
/** import single application imports in the section above, Sort Lines Ascending */

const AdHistory = createReactClass({
    displayName: 'AdHistory',

    statics: {
        refresh(dispatch, nextState) {
            const { adId, campaignId } = nextState.params;

            dispatch(fetchAdHistory(adId, campaignId));
        },
    },

    componentDidMount() {
        const { dispatch, location, params, routes } = this.props;
        const nextState = { location, params, routes };

        AdHistory.refresh(dispatch, nextState, browserHistory.push);
    },

    handleClose() {
        const {
            dispatch,
            params: { campaignId },
        } = this.props;
        browserHistory.push(`/campaigns/${campaignId}/setup/ads`);
        dispatch(closeAdHistory());
    },

    render() {
        const {
            isLoading,
            adName,
            historyEntries,
            organizationTimezone,
            organizationId,
            fields,
        } = this.props;

        return (
            <Dialog {...historyDialogProps} open={true} onClose={this.handleClose}>
                <DialogContent sx={historyDialogContentSx}>
                    <HistoryTableV3
                        title="Ad History"
                        secondaryTitle={adName}
                        historyEntries={historyEntries}
                        fields={fields}
                        organizationTimezone={organizationTimezone}
                        organizationId={organizationId}
                        isLoading={isLoading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={this.handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    },
});

export default connect(selector)(AdHistory);
